import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "l-header" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"ha-header\"><div class=\"ha-header__container\"><div class=\"ha-header__brand\"><div class=\"ha-header__shlogo\"><img src=\"" + _imports_0 + "\" alt=\"SHUEISHA ID\"></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _hoisted_3))
}